import { combineActions, handleActions } from 'redux-actions'

import { onUserReadyForCall } from '@tabeeb/modules/presentation/actions/connection'
import { leaveVideoCall } from '@tabeeb/shared/content/actions'
import { signalrConstants, signalrEvents } from '@tabeeb/modules/signalr'

export default handleActions(
  {
    [onUserReadyForCall.toString()]() {
      return Date.now()
    },
    [combineActions(leaveVideoCall, signalrEvents[signalrConstants.tabeebHubName].onCallEnded).toString()]() {
      return 0
    },
  },
  0
)
